import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../../shared/http-client';
import { formatDateTime, classNames } from '../../../../utils';
import { EyeIcon } from '@heroicons/react/outline';


export const AsignacionesTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {

    const { api, state } = useHttpClient();
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState<any | null>(null);

    useEffect(() => {
        api(`/fleet/assignments?driver=${id}`, 'GET');

    }, []);

    useEffect(() => {
        if (state.data) {
            if (state.path.includes('assignments')) {
                setData(state.data.results);
            }
        }

        if (state.error) {
            toast.error(state.error.detail);
        }
    }, [state]);



    return (
        <>
            <div className='flex p-4'>
                <span className=' font-semibold'>{item?.name}</span>
                <span className='pl-2  font-semibold'>{item?.surname}</span>

            </div>

            <div className='p-4'>
                {data && data.map((item: any) => {
                    return <div className='border border-gray-400 bg-gray-200 rounded p-4 mb-4'>
                        <div className='flex justify-start'>
                            <div className='pr-8'>
                                {item?.vehicle?.photo_display_url ? <img className='w-[180px] pb-4' src={item?.vehicle?.photo_display_url} /> : <div className='w-[180px] h-[120px] bg-gray-300'> </div>}

                            </div>
                            <div className='w-2/3'>
                                <div className='font-semibold flex text-[13px]'>
                                    <span>{item?.vehicle?.brand_name}</span>
                                    <span className='pl-2'>{item?.vehicle?.model.name}</span>
                                </div>
                                <div className='flex text-[13px]'>
                                    <span>{t('common.label.codigo-asignacion')}:</span>
                                    <div className='flex'>
                                        <span className='px-2'>{item?.code}</span>
                                        <div onClick={() => navigate(`/assignments/${item?.id}`)}><EyeIcon className={classNames('h-4 w-4 ', 'cursor-pointer pt-[2px]')} /></div>

                                    </div>

                                </div>
                                <div className='flex text-[13px]'>
                                    <span>{t('common.label.fecha-hora-asignacion')}:</span>
                                    <span className='pl-2'>{item?.assignment_datetime && formatDateTime(item?.assignment_datetime)}</span>
                                </div>
                                <div className='flex text-[13px]'>
                                    <span>{t('common.label.fecha-hora-finalizacion')}:</span>
                                    <span className='pl-2'>{item?.completion_datetime && formatDateTime(item?.completion_datetime)}</span>
                                </div>
                                <div className='flex text-[13px]'>
                                    <span>{t('common.label.km-registrados')}:</span>
                                    <span className='pl-2'>{item?.recorded_mileage}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                })}
            </div>
        </>



    );
};